module.exports = __webpack_public_path__ + "img/style-2.fdef5e02.svg";